<div>
  <div class="loader"></div>
  <span *ngIf="message" class="message">{{ message }} </span>
</div>
